import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './apple/Hero';
import Destaques from './apple/Destaques';
import Solucoes from './apple/Solucoes';
import { Turnkey, Dono, Showroom } from './apple/Turnkey';
import { Perguntas, Contato, PERGUNTAS } from './apple/Contato';
import { useSEO, useSchemaLD } from '@/hooks/useSEO';
import { SITE_URL, WHATSAPP_NUMBER } from '@/config/site';

export default function HomeOfficePremiumPage() {
  useSEO({
    title: 'Móveis Corporativos Caruaru e Recife | HomeOffice Premium',
    description:
      'Mobiliário corporativo para escritórios, clínicas, escolas e órgãos públicos. Cadeiras, mesas, divisórias e ambientes completos em Caruaru e Recife.',
    keywords:
      'móveis corporativos Caruaru, mobiliário corporativo Recife, cadeiras para escritório, fornecedor de móveis corporativos, móveis para empresas',
    path: '/',
    ogTitle: 'Mobiliário corporativo para empresas e instituições | HomeOffice Premium',
    ogDescription:
      'Soluções para escritórios, clínicas, escolas e órgãos públicos. Da primeira unidade à próxima expansão.',
  });

  useSchemaLD({
    id: 'schema-hop',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'HomeOffice Premium',
      description:
        'Mobiliário corporativo e institucional. Cadeiras, mesas, armários, divisórias, acústica e ambientes completos para empresas, clínicas, escolas e órgãos públicos. Showroom em Caruaru, Pernambuco.',
      url: SITE_URL,
      telephone: '+55-81-98203-0285',
      email: 'ednilsonleocadio@gmail.com',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Av. Agamenon Magalhães, 1519',
        addressLocality: 'Caruaru',
        addressRegion: 'PE',
        postalCode: '55014-000',
        addressCountry: 'BR',
      },
      geo: { '@type': 'GeoCoordinates', latitude: -8.2836, longitude: -36.0078 },
      areaServed: [
        { '@type': 'City', name: 'Caruaru' },
        { '@type': 'City', name: 'Recife' },
        { '@type': 'State', name: 'Pernambuco' },
      ],
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '08:00',
          closes: '18:00',
        },
        { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Saturday'], opens: '09:00', closes: '13:00' },
      ],
    },
  });

  useSchemaLD({
    id: 'schema-hop-faq',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: PERGUNTAS.map((p) => ({
        '@type': 'Question',
        name: p.q,
        acceptedAnswer: { '@type': 'Answer', text: p.a },
      })),
    },
  });

  const whatsappMsg = encodeURIComponent('Olá! Gostaria de conversar sobre móveis corporativos para minha empresa.');

  return (
    <div className="min-h-screen font-sans overflow-x-hidden bg-white text-[#1D1D1F]">
      <Navbar />

      <main className="pt-14 md:pt-16">
        <Hero />
        <Destaques />
        <Solucoes />
        <Turnkey />
        <Dono />
        <Showroom />
        <Perguntas />
        <Contato />
      </main>

      <Footer />

      <a
        href={`https://wa.me/${WHATSAPP_NUMBER}?text=${whatsappMsg}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-[60] w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-white/90 backdrop-blur text-[#1D9E4B] shadow-[0_4px_20px_rgba(0,0,0,0.12)] hover:scale-105"
        aria-label="Falar no WhatsApp"
      >
        <i className="ri-whatsapp-line text-[24px] md:text-[26px]"></i>
      </a>
    </div>
  );
}
